import { Pipe, PipeTransform } from '@angular/core';
import { SubscriptionDTO } from '@app/core/services/subscription/models/subscription/subscription.model';
import { MobilityAccount } from '@app/core/services/user/models/mobility-account.model';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'subscriptionHolderPayer',
    standalone: false
})
export class SubscriptionHolderPayerPipe implements PipeTransform {

  constructor (private translateService: TranslateService) {}

  transform(subscription: SubscriptionDTO, user: MobilityAccount): String {
    if(subscription.subscriptionPayer) {
      if (subscription.subscriptionPayer.accountId === user.mobilityAccountId) {
        return `(${this.translateService.instant('USER.TABS.PAYMENTS.PAYER')})`
      } else {
        return `(${this.translateService.instant('USER.TABS.PAYMENTS.HOLDER')})`
      }
    } else {
      return ''
    }
  }

}
